module.exports = __webpack_public_path__ + "static/cornerstonecourier-logo-0b73dbc914f8ac001200e188ce83637c.jpeg";